import { createContext, useContext } from 'react';

// The REAL router location, published by AppRoutes for consumers mounted
// inside <Routes location={...}>. When a location argument is passed, React
// Router wraps the rendered matches in a LocationContext.Provider scoped to
// that location, so useLocation() inside the routed tree (MainLayout and
// everything under it) returns the background view's location while a
// route-anchored modal is open. Modal hosts read this context instead.
export const RealLocationContext = createContext(null);

export function useRealLocation() {
  return useContext(RealLocationContext);
}
